let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hyC1C")).then(() => parcelRequire('1SQvU'));